<bn-loading-overlay></bn-loading-overlay>
<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>

<h5>Consulta de IPOC</h5>

<section class="pesquisa">
<div class="container">
  <form class="mt-3 mx-auto">
    <div class="mb-3 row">
      <div class="col">
        <h3>Pesquisa</h3>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button [disabled]="!idOperacao && !idIPOC" type="button" class="btn btn-success no-margin" (click)="buscar()">
        Pesquisar</button>
      </div>
    </div>
  </form>

  <div class="row">
    <div class="bn-form-group col-md-3">
      <label for="idOperacao">ID Operação:</label>
      <input type="text" class="form-control" pattern="\d*" 
      oninput="this.value = this.value.replace(/[^0-9]/g, '')" [(ngModel)]="idOperacao">
    </div>

    <div class="bn-form-group col-md-6">
      <label for="idIPOC">Número IPOC:</label>
      <input type="text" class="form-control"  [(ngModel)]="idIPOC">
  </div>
  <div *ngIf="pesquisado && idOperacao" class="bn-form-group col-md-3">
    <label for="opcaoTodosIpocs" class="pb-1"><b>Ver IPOCS Desativados:</b></label>
    <input type="checkbox" class="form-check checkbox-gigante" [(ngModel)]="opcaoMostrarTodosIpocs" (change)="trocarOpcaoMostrarTodosIpocs()">
  </div>
   
    <br>

    <div *ngIf="pesquisado" >
      <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="col nav-tabs" (navChange)="onNavChange($event)">
        <li [ngbNavItem]="0" title="IPOCs" [ngbNavItem]>
        <a ngbNavLink>IPOCs</a>
          <ng-template ngbNavContent>
            <app-aba-troca-ipoc
              [opcaoMostrarTodosIpocs]="opcaoMostrarTodosIpocs"
              [trocasIPOC]="trocasIPOC"
              [permissaoEdicao]="permissaoEdicao"
              [diasAtraso]="diasAtraso"
              [atributosPaginacaoAbaTrocaIpoc]="atributosPaginacaoAbaTrocaIpoc"
              [opcoesPaginacaoDiasAtraso]="opcoesPaginacaoDiasAtraso"
              [atributosPaginacaoAbaDiasAtraso]="atributosPaginacaoAbaDiasAtraso"
              [opcoesPaginacaoTrocaIpoc]="opcoesPaginacaoTrocaIpoc">
            </app-aba-troca-ipoc>
          </ng-template>
        </li>
      
        <li [ngbNavItem]="1" title="Consultas ao BACEN" [ngbNavItem]>
        <a ngbNavLink>Consultas ao BACEN</a>
          <ng-template ngbNavContent>
            <app-aba-consulta-bacen
              [consultasOperacaoScr]="consultasOperacaoScr"
              [atributosPaginacaoAbaConsultaBacen]="atributosPaginacaoAbaConsultaBacen"
              [opcoesPaginacaoAbaConsultaBacen]="opcoesPaginacaoAbaConsultaBacen">
            </app-aba-consulta-bacen>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
      
  </div>
</div>
</section>